import React from 'react'
import file1 from '../assets/files/1/Mobility Town Hall Presentation.pdf'
import file2 from '../assets/files/2/Neighorhoods Town Hall Presentation.pdf'
import file3 from '../assets/files/5/Parks Town Hall Presentation.pdf'
import file4 from '../assets/files/7/Places Town Hall Presentation.pdf'
import file5 from '../assets/files/8/Economic Development Town Hall Presentation.pdf'
import file6 from '../assets/files/9/Resiliency Town Hall Presentation.pdf'
import file7 from '../assets/files/10/FLUP Presentation.pdf'



export default function GetInvolved() {
    return (
        <div>

            <main role="main" className="flex-shrink-0 modular min-vh-100 my-5">

                <div className='container my-5 py-5'>

                    <div className="row text-start">
                        <h2>Get Involved!</h2>
                    </div>

                    <div className="row text-start">
                        <h3>Facebook Live Town Hall Events</h3>

                        <p>Join us each Wednesday at 5:30pm for a Town Hall on each of the Core Values! Please visit the <a href="https://www.facebook.com/BurlesonTX/" target="_blank">
                            City of Burleson, Texas Government Facebook Page</a> to join the events.</p>

                        <div className='container'>
                            <ul>
                                <li>
                                    Wednesday, August 26, 2020 @ 5:30pm - Mobility
                                    <ul>
                                        <li><a href={file1} target="_blank">Mobility Town Hall Presentation</a></li>
                                    </ul>
                                </li>

                                <li>
                                    Wednesday, September 02, 2020 @ 5:30pm - Neighborhoods
                                    <ul>
                                        <li><a href={file2} target="_blank">Neighborhoods Town Hall Presentation</a></li>
                                    </ul>
                                </li>

                                <li>
                                    <del>Wednesday, September 09, 2020 @ 5:30pm - <del>Parks</del></del>
                                    <br />
                                    <em>Parks will be covered Sept. 16</em>
                                    <ul>
                                        <li><a href={file3} target="_blank">Parks Town Hall Presentation</a></li>
                                    </ul>
                                </li>

                                <li>
                                    Wednesday, September 16, 2020 @ 5:30pm - Parks and Places
                                    <ul>
                                        <li><a href={file4} target="_blank">Places Town Hall Presentation</a></li>
                                    </ul>
                                </li>

                                <li>
                                    Wednesday, September 23, 2020 @ 5:30pm - Economic Development
                                    <ul>
                                        <li><a href={file5} target="_blank">Economic Development Town Hall Presentation</a></li>
                                    </ul>
                                </li>

                                <li>
                                    Wednesday, September 30, 2020 @ 5:30pm - Resiliency
                                    <ul>
                                        <li><a href={file6} target="_blank">Resiliency Town Hall Presentation</a></li>
                                    </ul>
                                </li>

                                <li>
                                    Wednesday, October 07, 2020 @ 5:30pm - Future Land Use
                                    <ul>
                                        <li><a href={file7} target="_blank">Future Land Use Town Hall Presentation</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>


                    </div>

                    <div className="row text-start">

                        <h3>Online Surveys</h3>
                    </div>
                    <div className="row text-start">
                        <p>We will launch a survey for each Core Value statement. Miss a survey and still want to provide input on that topic? Please share your comments on the <a href="/CoreValues">Core Value page</a> or join a Focus Group</p>
                    </div>
                    <div className="row text-start">
                        <div className='container'>
                            <ul>
                                <li>Mobility Survey<em> (closed Friday, September 4, 2020) </em></li>
                                <li>Neighborhoods Survey <em>(closed Thursday, September 17, 2020)</em></li>
                                <li>Parks Survey <em>(closed Thursday, September 17, 2020)</em></li>
                                <li>Places Survey<em> (closed Friday, September 25, 2020)</em></li>
                                <li>Economic Development Survey <em>(closed Friday, October 2, 2020)</em></li>
                                <li>Resiliency Survey <em>(closed  Thursday, October 8, 2020)</em></li>
                                <li>Future Land Use Survey <em>(closed Friday, October 16, 2020)</em></li>
                            </ul>
                        </div>
                    </div>

                    <div className="row text-start">
                        <h3>Zoom Focus Groups</h3>

                        <p>Interested in sharing more input on a particular Core Value? We would love to hear your thoughts! Please email <a href="mailtp:mclark@burlesontx.com">mclark@burlesontx.com</a> to sign up for a virtual focus group. </p>
                    </div>

                </div>


            </main>

        </div>
    )
}
